<div class="breadCrumb">
    <a (click)="goTo(item)" *ngFor="let item of data">{{item.name}}</a>
</div>